var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    width: 85,
    height: 85,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timeOnPlatform-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00a094 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m76.1 63.2c-1.5-1.1-3.5-0.8-4.6 0.7q-1 1.2-2 2.3c-1.2 1.4-1 3.5 0.3 4.7 0.7 0.6 1.4 0.9 2.2 0.9 0.9 0 1.9-0.4 2.5-1.2q1.2-1.3 2.3-2.8c1.1-1.4 0.8-3.5-0.7-4.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m81.7 47.6c-1.8-0.4-3.6 0.8-4 2.6q-0.3 1.5-0.8 2.9c-0.5 1.8 0.5 3.6 2.2 4.2q0.5 0.1 1 0.1c1.4 0 2.7-0.9 3.2-2.3q0.5-1.8 0.9-3.5c0.4-1.8-0.8-3.6-2.5-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m60.1 73.8q-1.3 0.8-2.7 1.4c-1.7 0.8-2.4 2.7-1.7 4.4 0.6 1.2 1.8 1.9 3.1 1.9q0.7 0 1.3-0.2 1.7-0.8 3.3-1.7c1.6-0.9 2.1-2.9 1.2-4.5-0.9-1.6-2.9-2.2-4.5-1.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "CPA",
    className: "s0",
    "aria-label": "CPA",
    d: "m25.6 51.2q-4.5 0-6.7-1.9-2.1-1.9-2.1-5.5 0-3.6 2.1-5.7 2.2-2 6.7-2 6.3 0 8.5 4.3-1.8 0.6-4.3 1.9-0.5-1.2-1.8-1.7-1.2-0.5-2.5-0.5-2 0-2.9 1-0.9 1-0.9 2.5 0 1.6 1 2.6 1 1 3.1 1 1.6 0 2.6-0.6 1-0.5 1.4-1.7 1.7 0.9 4.2 2-1 2.4-3.3 3.3-2.3 1-5.1 1zm15-14.7h4.1q4 0 5.6 1.4 1.5 1.4 1.5 4 0 1.7-0.6 3-0.6 1.2-2.2 1.9-1.5 0.7-4.3 0.7h-4.1v3.5h-4.9q0.1-3.9 0.1-7.3 0-3.3-0.1-7.2h4.9zm0 7.1h2.7q1.7 0 2.5-0.1 0.9-0.2 1.2-0.5 0.3-0.3 0.3-1 0-0.7-0.3-1-0.3-0.3-1.1-0.4-0.9-0.2-2.6-0.2h-2.7zm28.6 7.4h-5.1q-0.4-1.1-1.1-2.8h-6.3l-1 2.8h-5.1l5.6-14.5h7.4zm-11.4-6h4.1q-0.8-2.1-1.6-4.2l-0.5-1.3q-0.7 1.8-2 5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m81.7 7.1c-1.9 0-3.3 1.5-3.3 3.4v9.2c-7.8-12.1-21.3-19.7-35.9-19.7-11.4 0-22 4.4-30.1 12.4-8 8.1-12.4 18.7-12.4 30.1 0 11.4 4.4 22 12.4 30.1 8.1 8 18.7 12.4 30.1 12.4q0 0 0.1 0 0 0 0.1 0 1.8 0 3.6-0.1c1.8-0.2 3.1-1.8 3-3.6-0.2-1.9-1.8-3.2-3.6-3.1q-1.5 0.2-3 0.2-0.1 0-0.1 0-0.1 0-0.1 0c-19.8 0-35.9-16.1-35.9-35.9 0-19.8 16.1-35.9 35.9-35.9 12.7 0 24.5 6.8 30.9 17.6h-9.2c-1.8 0-3.3 1.5-3.3 3.4 0 1.8 1.5 3.3 3.3 3.3h10.2c2 0 3.9-0.6 5.5-1.6q0.2-0.1 0.3-0.2c2.9-1.9 4.8-5.1 4.8-8.8v-9.8c0-1.9-1.5-3.4-3.3-3.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpa);
export default __webpack_public_path__ + "static/media/cpa.c10793eb41f04b411b0712c7a529847f.svg";
export { ForwardRef as ReactComponent };